"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.perCharTime = exports.max = exports.min = void 0;
// based on: https://ux.stackexchange.com/questions/11203/how-long-should-a-temporary-notification-toast-appear
// min time to display alert
var min = 3000; // max time to display alert

exports.min = min;
var max = 10000; // multiplier

exports.max = max;
var perCharTime = 50;
exports.perCharTime = perCharTime;

var _default = function _default(text) {
  return Math.min(Math.max(text.length * perCharTime, min), max);
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-web/components/alerts/BaseAlert/duration.js
// module id = ./node_modules/quark-web/components/alerts/BaseAlert/duration.js
// module chunks = 0